import { axiosGet } from './axiosService';

const baseUrl = 'DirectDebit';

export class DirectDebitService {
	getMandateByLoanId(loanId) {
		return axiosGet(null, `${baseUrl}/mandates/loan/${loanId}`);
	}

	getMandateStatus(mandateId) {
		return axiosGet(null, `${baseUrl}/mandates/${mandateId}/status`);
	}

	getSignedPdf(mandateId) {
		return axiosGet(null, `${baseUrl}/mandates/${mandateId}/signed-pdf`, null, 'blob');
	}

	getUnsignedPdf(mandateId) {
		return axiosGet(null, `${baseUrl}/mandates/${mandateId}/unsigned-pdf`, null, 'blob');
	}

	getUaePassSignerUrl(mandateId, redirectUrl = null) {
		const params = redirectUrl ? `?redirectUrl=${encodeURIComponent(redirectUrl)}` : '';
		return axiosGet(null, `${baseUrl}/mandates/${mandateId}/uaepass-signer-url${params}`);
	}

	getPaymentsByMandateId(mandateId) {
		return axiosGet(null, `${baseUrl}/mandates/${mandateId}`);
	}
}
